import React from 'react';
import { useTranslation } from 'react-i18next';
import { scrollWithOffset } from '../../../Common/Utils/scroller';
import { Path } from '../../../Routing';
import env from '../../../env';
import { StyledA, StyledHashLink, Header } from './sharedStyles';
import { HashLinkPathsIds } from '../../../Routing/HashLinkPathIds';
import ButtonLink from '../../../Common/Buttons/Links/ButtonLink';
import styled from 'styled-components';
import { mobileMediaQuery, themeColor, useBreakPoints } from '../../../Theming';
import { MAIL_TO_SDK_COMMERCIAL_TEAM } from './Connect';

const StyledButtonLink = styled(ButtonLink)`
  width: 180px;
  margin-top: 103px;

  ${mobileMediaQuery} {
    margin-top: 40px;
  }
`;

const ButtonLinkSecondary = styled(ButtonLink)`
  width: 180px;
  margin-top: 103px;
  background-color: ${themeColor('mediumGreen')};
  margin-left: 25px;
  border: 0px;

  ${mobileMediaQuery} {
    margin-top: 25px;
    margin-left: 0px;
    margin-bottom: 40px;
  }
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${mobileMediaQuery} {
    flex-direction: column;
  }
`;
const CompanyLinks: React.FC = () => {
  const { t } = useTranslation();
  const { tablet } = useBreakPoints();

  return (
    <>
      <Header>{t('footer.company')}</Header>
      <StyledHashLink
        to={Path.AboutUs}
        scroll={scrollWithOffset}
        elementId={HashLinkPathsIds.Root}
        smooth
      >
        {t('legal.about')}
      </StyledHashLink>
      <StyledA
        href={env.sdk_documentation_url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('legal.sdkDocumentation')}
      </StyledA>
      <StyledHashLink
        to={Path.UnderTheHood}
        scroll={scrollWithOffset}
        elementId={HashLinkPathsIds.Root}
        smooth
      >
        {t('legal.faqs')}
      </StyledHashLink>
      <StyledA
        href={env.privacy_policy_url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('legal.privacyPolicy')}
      </StyledA>
      <StyledA
        href={env.terms_and_conditions_url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('legal.termsAndConditions')}
      </StyledA>

      {tablet && (
        <RowContainer>
          <StyledButtonLink href={MAIL_TO_SDK_COMMERCIAL_TEAM}>
            {t('footer.contactUs')}
          </StyledButtonLink>
          <ButtonLinkSecondary href={env.get_api_key_url}>
            {t('footer.getAPIKey')}
          </ButtonLinkSecondary>
        </RowContainer>
      )}
    </>
  );
};

export default CompanyLinks;
